export type HTMLElementOrShadowRoot = HTMLElement | ShadowRoot;

/**
 * Light DOM
 */
const getNamedSlot = (el: HTMLElement, slotName: string): HTMLElement => el.querySelector(`[slot="${slotName}"]`);

const hasNamedSlot = (el: HTMLElement, slotName: string): boolean => !!getNamedSlot(el, slotName);

// descriptive name than getNamedSlot
const getSlottedNamedLDomElem = (el: HTMLElement, slotName: string): HTMLElement =>
  el.querySelector(`[slot="${slotName}"]`);

/**
 * Shadow DOM
 */

/**
 * Checks if the component has a default slot that has assigned nodes to it.
 * - Node.ELEMENT_NODE (Typ 1) are visible elements.
 * - Node.TEXT_NODE (Typ 3) are text nodes.
 * - Important usage note: DO NOT USE THIS FUNCTION DIRECTLY IN YOUR JSX, CALL IT ON 'componentDidLoad'
 */
const hasDefaultSlotWithContent = (hostElement: HTMLElement): boolean => {
  const defaultSlot = hostElement.shadowRoot.querySelector<HTMLSlotElement>('slot:not([name])') ?? false;

  if (!defaultSlot) return false;

  const assignedNodes = defaultSlot.assignedNodes({ flatten: true });
  for (const node of assignedNodes) {
    if (node.nodeType !== 3 || (node.nodeType === 3 && node.textContent.trim() !== '')) {
      return true;
    }
  }
  return false;
};

export { getNamedSlot, getSlottedNamedLDomElem, hasDefaultSlotWithContent, hasNamedSlot };
